<template>
    <app-primary>
        <template #contentsHead>
            <sub-head-primary itemTitle="사업안내" tabActive="사업개요" bg="/images/sub/business/visual.jpg">
                <template #title>사업안내</template>
            </sub-head-primary>
        </template>

        <page-section-primary titWrapClass="text-center" class="page-section--first page-section--last">
            <template #tit>사업개요</template>

            <div class="overview-slide">
                <swiper :options="swiperOptions">
                    <template v-for="(image, index) in images">
                        <swiper-slide :key="index">
                            <div class="image-wrap">
                                <v-card tile flat :img="image">
                                    <v-responsive :aspect-ratio="1200 / 748" />
                                </v-card>
                            </div>
                        </swiper-slide>
                    </template>
                </swiper>
                <div class="swiper-control">
                    <v-btn color="grey lighten-3" icon x-large outlined class="swiper-button-prev">
                        <icon-chevron direction="left" class="grey--text" />
                    </v-btn>
                    <v-btn color="grey lighten-3" icon x-large outlined class="swiper-button-next">
                        <icon-chevron direction="right" class="grey--text" />
                    </v-btn>
                </div>
            </div>
            <swiper-pagination-quarternary />

            <table-primary :items="items" :headers="headers" class="overview-table">
                <template v-slot:body="{ items }">
                    <tbody>
                        <tr v-for="header in headers" :key="header.text">
                            <th-tertiary>{{ header.text }}</th-tertiary>
                            <td-secondary v-for="item in items" :key="item.text">{{ item[header.value] }}</td-secondary>
                        </tr>
                    </tbody>
                </template>
            </table-primary>
        </page-section-primary>
    </app-primary>
</template>

<script>
import AppPrimary from "@/sets/parents/apps/app-primary.vue";
import SubHeadPrimary from "@/sets/parents/pages/sub-head-primary.vue";
import PageSectionPrimary from "@/sets/parents/pages/page-section-primary.vue";
import TablePrimary from "@/components/publish/parents/tables/table-primary.vue";
import ThTertiary from "@/components/publish/parents/tables/th-tertiary.vue";
import TdSecondary from "@/components/publish/parents/tables/td-secondary.vue";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import SwiperBtnWrapPrimary from "@/components/publish/parents/swipers/swiper-btn-wrap-primary.vue";
import SwiperButtonSecondary from "@/components/publish/parents/swipers/swiper-button-secondary.vue";
import SwiperPaginationQuarternary from "@/components/publish/parents/swipers/swiper-pagination-quarternary.vue";
import IconChevron from "@/components/publish/styles/icons/icon-chevron.vue";

export default {
    props: {},
    components: {
        AppPrimary,
        SubHeadPrimary,
        PageSectionPrimary,
        TablePrimary,
        ThTertiary,
        TdSecondary,
        Swiper,
        SwiperSlide,
        SwiperBtnWrapPrimary,
        SwiperPaginationQuarternary,
        SwiperButtonSecondary,
        IconChevron,
    },
    data() {
        return {
            swiperOptions: {
                allowTouchMove: true,
                spaceBetween: 24,
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                },
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },
                autoplay: {
                    delay: 5000,
                    disableOnInteraction: false,
                },
                speed: 500,
                loop: true,
            },
            images: [
                "/images/sub/business/overview/overview-1.jpg",
                "/images/sub/business/overview/overview-2.jpg",
                "/images/sub/business/overview/overview-3.jpg",
                //
            ],
            headers: [
                { text: "주택위치", value: "주택위치" },
                { text: "공급호수", value: "공급호수" },
                { text: "단지명", value: "단지명" },
                { text: "시행사(임대사업자)", value: "시행사" },
                { text: "시공사", value: "시공사" },
                { text: "입주예정", value: "입주예정" },
            ],
            items: [
                {
                    주택위치: "서울특별시 광진구 자양동 8-8번지 외 3필지(290-12) (2, 7호선 건대입구역 6번 출구)",
                    공급호수: "총480세대 중 공공지원민간임대 313세대 (특별공급 63세대, 일반공급 250세대)",
                    단지명: "더포디엄 830",
                    시행사: "㈜엘앤케이이스테이트",
                    시공사: "코오롱글로벌㈜, 코오롱이앤씨㈜",
                    입주예정: "2025년 02월 예정 (추후 변동 가능)",
                },
            ],
        };
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped>
.overview-slide {
    position: relative;
    .swiper-control {
        height: auto;
        .swiper-button-prev,
        .swiper-button-next {
            &::after {
                display: none;
            }
        }
        .swiper-button-prev {
            left: -30px;
            transform: translate(-100%, -50%);
        }
        .swiper-button-next {
            right: -30px;
            transform: translate(100%, -50%);
        }
    }
}
.swiper-pagination {
    margin: 24px 0;
    position: static;
    transform: initial;
    justify-content: center;
}
.overview-table {
    tbody > tr > th {
        width: 30%;
    }
}
@media (min-width: 768px) {
    .overview-slide {
        .swiper-pagination {
            margin: 40px 0;
        }
    }
    .overview-table tbody > tr > th {
        width: 15%;
    }
}
</style>
